// extracted by mini-css-extract-plugin
export default {"backdrop":"ConfirmationModal_backdrop__oYRDM","modal":"ConfirmationModal_modal__WNvBX","appear":"ConfirmationModal_appear__xMltl","footer":"ConfirmationModal_footer__oo0gy"};